import { render } from "./management.cattle.io.project.vue?vue&type=template&id=b4b02f58&scoped=true"
import script from "./management.cattle.io.project.vue?vue&type=script&lang=js"
export * from "./management.cattle.io.project.vue?vue&type=script&lang=js"

import "./management.cattle.io.project.vue?vue&type=style&index=0&id=b4b02f58&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4b02f58"]])

export default __exports__